import { LoadBalancersTable } from "@/admin/load_balancers/LoadBalancersTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/load_balancers")({
    component: LoadBalancersTable,
});
